import React from 'react';
import { useState, useEffect } from 'react';
import './classes/SalaryOfferings.css';
import { configData } from "../config";

// The "Offerings:" block in the right column of the live site's salary pages (Drupal custom block
// 74): a card for each course offered on the page, with the course's next start date, its name,
// its picture, a few lines typed into the block and a "Learn more and apply today" button. The
// names, pictures and lines are typed into the block; the start dates are the courses' own (the
// date on each course's page), and a course with no start date gets no card. The pictures are the
// live site's, through its picture CDN as live loads them (a few KB each; the Drupal copy's are the
// full-size files).
const files_url = configData.IMAGE_CDN_URL + configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';

// The Courses page, where every course offered here is placed: pages/getcourses lists their start
// dates and addresses
const COURSES_PAGE_NID = 64;

const COURSES = {
    505: {
        title: 'Athlete Management - Become A Sports Agent',
        picture: 'lashbrook_0_0.jpg',
        text: <>The <b>Athlete Management Course</b> provides aspiring sports agents the skills, strategies, and requirements to represent professional athletes. This is a premiere, one-of-a-kind, 8-week online interactive...</>,
    },
    167018: {
        title: 'Baseball Agent',
        picture: 'John boggs tile.png',
        text: <>Becoming a trusted <b>baseball agent</b> requires an eye for scouting, the personality for recruiting, and the brainpower for negotiation. In our 8-week online class, we'll begin building your foundation as...</>,
    },
    187229: {
        title: 'Basketball Agent',
        picture: 'bret_kanis.png',
        text: <>The <b>Basketball Agent Course</b> is an 8-week online class, we’ll begin building your foundation as a basketball agent and make you ready for today’s global marketplace.</>,
    },
    710: {
        title: 'Salary Cap Analysis',
        picture: 'nick polk tile image.png',
        text: <>The <b>Salary Cap Analysis Course</b> is an 8 week online Salary Cap Analysis Course for the NFL, NHL, NBA, MLS, MLB and international sports. Collective Bargaining Agreements evaluated. Learn to how to evaluate player contracts and player salaries.</>,
    },
    803: {
        title: 'Soccer Agent',
        picture: 'Maikel tusji tile image_0.png',
        text: <>The <b>Soccer Agent Course</b> provides a unique and practical opportunity to learn how to represent and promote professional soccer players. This course is suitable for students who are looking to gain an...</>,
    },
    261641: {
        title: 'Hockey Agent',
        picture: 'rick curran updated titles.png',
        text: <>The <b>Hockey Agent Course</b> is an 8-week online class, we’ll begin building your foundation as a hockey agent ready for today’s global ...</>,
    },
};

// The salary pages and the courses each one offers, in the block's order. The live Football page
// shows the heading alone.
export const SALARY_PAGES = {
    613: [505, 167018, 187229, 710, 803], // /program/salaries
    328605: [261641],                     // /program/hockey-agent-salaries
    328603: [167018],                     // /program/baseball-agent-salaries
    328835: [803],                        // /program/soccer-agent-salaries
    328602: [],                           // /program/football-agent-salaries
    328604: [187229],                     // /program/basketball-agent-salaries
    329040: [505],                        // /program/cricket-agent-salaries
    328836: [505],                        // /program/rugby-agent-salaries
};

export const isSalaryPage = (page) => page?.type === 'page' && Object.prototype.hasOwnProperty.call(SALARY_PAGES, Number(page?.nid));

const SalaryOfferings = ({ page }) => {
    // The offered courses' start dates and addresses by nid, once loaded
    const [courses, setCourses] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetch(configData.APP_URL + 'pages/getcourses?nid=' + COURSES_PAGE_NID, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => response.json())
            .then((data) => {
                const byNid = {};
                (data?.data?.items || []).forEach((item) => { byNid[item.nid] = item; });
                if (!cancelled) setCourses(byNid);
            })
            .catch(() => { if (!cancelled) setCourses({}); });
        return () => { cancelled = true; };
    }, []);

    const offered = SALARY_PAGES[Number(page?.nid)];
    if (!offered || courses === null) return null;
    const cards = offered.filter((nid) => courses[nid]?.month && courses[nid]?.day);
    return (
        <div id="block-block-74" className="salary-offerings">
            <h2 className="salary-offerings__title">Offerings:</h2>
            {cards.map((nid) => (
                <div key={nid} className="salary-offerings__card">
                    <div className="salary-offerings__date">
                        <h5 className="salary-offerings__date-label">COURSE START DATE</h5>
                        <h5 className="salary-offerings__date-value">{courses[nid].month} {courses[nid].day}</h5>
                    </div>
                    <div className="salary-offerings__name">
                        <a href={courses[nid].link}>{COURSES[nid].title}</a>
                    </div>
                    <img className="salary-offerings__picture" src={files_url + encodeURIComponent(COURSES[nid].picture)} width="263" height="227" alt={COURSES[nid].title} />
                    <p className="salary-offerings__text">{COURSES[nid].text}</p>
                    {/* The block has a space on a line of its own above the button, and an empty
                        paragraph under it */}
                    <div className="salary-offerings__gap">&nbsp;</div>
                    <a className="reddbtnn salary-offerings__apply" href="/application">
                        <span className="salary-offerings__apply-small">LEARN MORE AND</span>{' '}
                        <span className="salary-offerings__apply-large"> APPLY TODAY</span>
                    </a>
                    <p className="salary-offerings__end">&nbsp;</p>
                </div>
            ))}
        </div>
    );
};

export default SalaryOfferings;
